module.exports = __webpack_public_path__ + "static/media/GA_Post_2018.12.16-1.5c8b07fd.jpg";